import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLogin: false,
        betslip: [],
        dataActive: [],
        accountSetting: {},
        gameLength: 1,
        stakePrice: [],
        itemRenderResult: 18,
        isMobile: false,
        showButtonPlaceDemo: false,
    },
    mutations: {
        SET_BETSLIP(state, data) {
            const { dataActive, betslip } = data
            state.betslip = betslip
            state.dataActive = dataActive
            localStorage.setItem('betslip', JSON.stringify(betslip))
            localStorage.setItem('dataActive', JSON.stringify(dataActive))
        },
        SET_PRICE_BETSLIP(state, betslip) {
            state.betslip = betslip
            localStorage.setItem('betslip', JSON.stringify(betslip))
        },
    },
    actions: {
        addToBetslip({ commit, state }, payload) {
            const { number, title, icon } = payload
            let accountSetting: any = state.accountSetting
            let betslip: any = state.betslip
            let dataActive: any = state.dataActive
            let gameLength: any = state.gameLength - 1

            const MIN = parseFloat(accountSetting.min_amount)

            const indexNumber = dataActive.findIndex((x) => x === number)
            if (indexNumber === -1) {
                let name = `${number} - ${title}`
                let win = MIN * parseInt(gameLength)
                let item = {
                    number,
                    name,
                    win,
                    price: MIN,
                    icon: icon.unactive,
                }
                betslip.push(item)
                dataActive.push(number)
            } else {
                let index = betslip.findIndex((x) => x.number === number)
                betslip.splice(index, 1)
                dataActive.splice(indexNumber, 1)
            }
            let param = {
                betslip,
                dataActive,
            }
            commit('SET_BETSLIP', param)
        },
        removeTobetslip({ commit, state }, payload) {
            const { number } = payload
            const betslip: any = state.betslip
            const dataActive: any = state.dataActive

            const indexNumber = dataActive.findIndex((x) => x === number)
            if (indexNumber !== -1) {
                const index = betslip.findIndex((x) => x.number === number)

                betslip.splice(index, 1)
                dataActive.splice(indexNumber, 1)

                const param = {
                    betslip,
                    dataActive,
                }
                commit('SET_BETSLIP', param)
            }
        },
        onClearbetslip({ commit }) {
            let betslip = []
            let dataActive = []
            let param = {
                betslip,
                dataActive,
            }
            commit('SET_BETSLIP', param)
        },
        updateWinBetslip({ commit, state }, payload) {
            let { index, stake } = payload
            let betslip: any = [...state.betslip]
            let accountSetting: any = state.accountSetting
            let gameLength: any = state.gameLength - 1

            const MIN = parseFloat(accountSetting.min_amount)
            const MAX = parseFloat(accountSetting.max_amount)

            stake = stake > MAX ? MAX : stake
            stake = stake < MIN ? MIN : stake

            betslip[index].price = stake
            betslip[index].win = betslip[index].price * parseInt(gameLength)
            betslip[index].stake = parseInt(stake)
            commit('SET_PRICE_BETSLIP', betslip)
        },

        updatePriceBetslip({ commit, state }, payload) {
            let { index, price } = payload
            let betslip: any = [...state.betslip]
            let accountSetting: any = state.accountSetting
            let gameLength: any = state.gameLength - 1

            const MIN = parseFloat(accountSetting.min_amount)
            const MAX = parseFloat(accountSetting.max_amount)

            price = parseInt(price) > MAX ? MAX : price
            price = parseInt(price) < MIN ? MIN : price

            betslip[index].price = price
            betslip[index].win = betslip[index].price * parseInt(gameLength)
            commit('SET_PRICE_BETSLIP', betslip)
        },
    },
})
